// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K5Y6","fullView":"styles_fullView__zK6Zs"};